// extracted by mini-css-extract-plugin
module.exports = {"gameWrapper":"_1yUUBAi","backdrop":"_3kXM-jW","close":"_1XneaO8","game":"_9KLxvZ_","gameIframe":"_2E1gMjn"};